import { useLanguage } from "@/contexts/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQPage = () => {
  const { t } = useLanguage();

  const faqs = [
    {
      question: t("faq.q1"),
      answer: t("faq.a1"),
    },
    {
      question: t("faq.q2"),
      answer: t("faq.a2"),
    },
    {
      question: t("faq.q3"),
      answer: t("faq.a3"),
    },
    {
      question: t("faq.q4"),
      answer: t("faq.a4"),
    },
    {
      question: t("faq.q5"),
      answer: t("faq.a5"),
    },
    {
      question: t("faq.q6"),
      answer: t("faq.a6"),
    },
    {
      question: t("faq.q7"),
      answer: t("faq.a7"),
    },
    {
      question: t("faq.q8"),
      answer: t("faq.a8"),
    },
    {
      question: t("faq.q9"),
      answer: t("faq.a9"),
    },
    {
      question: t("faq.q10"),
      answer: t("faq.a10"),
    },
    {
      question: t("faq.q11"),
      answer: t("faq.a11"),
    },
    {
      question: t("faq.q12"),
      answer: t("faq.a12"),
    },
    {
      question: t("faq.q13"),
      answer: t("faq.a13"),
    },
  ];

  return (
    <div className="pt-16">
      <div className="bg-secondary">
        <div className="container mx-auto py-16 px-4 md:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {t("faq.title")}
          </h1>
          <p className="text-xl text-muted-foreground">
            {t("faq.description")}
          </p>
        </div>
      </div>

      <div className="container mx-auto py-12 px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent>{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="max-w-3xl mx-auto mt-12 p-6 bg-secondary rounded-lg">
          <h3 className="text-xl font-bold mb-3">{t("faq.not.found")}</h3>
          <p className="mb-4">{t("faq.contact.description")}</p>
          <div className="flex justify-start">
            <a
              href="/contact"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring bg-primary text-primary-foreground shadow hover:bg-primary/90 h-9 px-4 py-2"
            >
              {t("nav.contact")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
